function firstValue(value) {
  return Array.isArray(value) ? value[0] : value
}

function normalizeSubChannelId(subChannelId) {
  const value = String(firstValue(subChannelId) ?? '').trim()
  if (!/^[1-9]\d*$/.test(value)) return ''

  const numericValue = Number(value)
  return Number.isSafeInteger(numericValue) ? numericValue : ''
}

export function resolveChannelAttribution(query = {}) {
  const promoteCode = String(firstValue(query.promote_code) ?? '').trim()
  if (!promoteCode) return null

  return {
    promoteCode,
    subChannelId: normalizeSubChannelId(query.sub_channel_id)
  }
}

export function mergeChannelAttribution(data = {}, promoteCode, subChannelId) {
  const result = { ...data }
  const normalizedPromoteCode = String(firstValue(promoteCode) ?? '').trim()
  if (normalizedPromoteCode) result.promote_code = normalizedPromoteCode
  else delete result.promote_code

  const normalizedSubChannelId = normalizeSubChannelId(subChannelId)
  if (normalizedSubChannelId) result.sub_channel_id = normalizedSubChannelId
  else delete result.sub_channel_id

  return result
}
